
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bengaluru",
      function () {
        return require("private-next-pages/bengaluru/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bengaluru"])
      });
    }
  